{
  "welcome": {
    "title": "Benvenuto in WrongStack",
    "subtitle": "Collega un provider per iniziare.",
    "heroTitle": "Da dove vuoi iniziare?",
    "heroTitleInProject": "Da dove vuoi iniziare in {{name}}?",
    "heroSubtitle": "L'agente è connesso al tuo progetto e pronto a leggere, modificare, eseguire comandi, cercare nel codebase, tenere traccia dei todo e ricordare il contesto tra le sessioni. Scegli un prompt di partenza qui sotto, scrivi il tuo, oppure digita / per la palette dei comandi completa.",
    "workingDirectory": "Directory di lavoro: {{cwd}}",
    "noKeyTitle": "Nessuna chiave API configurata",
    "noKeyBody": "Registra un provider in Impostazioni prima di inviare un messaggio — altrimenti l'agente non ha nessuno con cui parlare. Anthropic, OpenAI, Google e qualsiasi endpoint compatibile con OpenAI funzionano tutti.",
    "openSettings": "Apri Impostazioni",
    "pickBackUp": "Riprendi",
    "recentPrompts": "Prompt recenti",
    "quickCommands": "Comandi rapidi",
    "startingPrompts": "Prompt iniziali",
    "shufflePrompts": "Mescola",
    "shufflePromptsHint": "Mostra un nuovo set di prompt iniziali",
    "empty": "(vuoto)",
    "card": {
      "understand": {
        "title": "Capire",
        "hint": "Esplora e analizza il codebase"
      },
      "create": {
        "title": "Creare",
        "hint": "Crea nuove funzionalità"
      },
      "investigate": {
        "title": "Indagare",
        "hint": "Esegui il debug dei problemi e trova le cause principali"
      },
      "improve": {
        "title": "Migliorare",
        "hint": "Effettua il refactoring e ottimizza il codice esistente"
      }
    },
    "slashRef": {
      "help": "elenca ogni comando slash",
      "diag": "diagnostica di runtime",
      "stats": "token · cache · costo · tempo trascorso",
      "tools": "mostra gli strumenti registrati",
      "memory": "mostra le note memorizzate",
      "compact": "riduci il contesto",
      "clear": "cancella il contesto corrente",
      "new": "nuova sessione"
    }
  },
  "provider": {
    "heading": "Scegli un provider",
    "keyPlaceholder": "Incolla la tua chiave API",
    "connect": "Connetti",
    "connected": "Connesso"
  },
  "screen": {
    "header": {
      "title": "Benvenuto in WrongStack",
      "subtitle": "Aggiungi almeno una chiave API per iniziare",
      "continue": "Continua"
    },
    "steps": {
      "addKeys": "Aggiungi chiavi API",
      "pickModel": "Scegli un modello",
      "start": "Avvia",
      "keys": "Chiavi"
    },
    "security": {
      "title": "Le tue chiavi restano sul tuo dispositivo",
      "body": "Le chiavi API sono crittografate e salvate localmente. Vengono inviate solo all'endpoint API del provider — mai a noi o a terzi."
    },
    "errors": {
      "backendUnreachable": "Backend non raggiungibile",
      "backendNotResponding": "Il backend non risponde. Potrebbe essersi bloccato o la connessione potrebbe essere caduta.",
      "retry": "Riprova",
      "modelSwitchTimeout": "Timeout del cambio modello. Riprova.",
      "noModels": "Nessun modello disponibile. Controlla la tua chiave API e riprova."
    },
    "providers": {
      "popular": "Provider popolari",
      "more": "Altri provider",
      "selfHosted": "Self-hosted",
      "updating": "Aggiornamento...",
      "refresh": "Aggiorna",
      "refreshTitle": "Aggiorna l'elenco dei provider",
      "modelsAvailable_one": "{{count}} modello disponibile",
      "modelsAvailable_other": "{{count}} modelli disponibili",
      "catalogDescription": "{{family}} · {{count}} modelli"
    },
    "start": {
      "pickAndStart": "Scegli un modello e avvia",
      "addMoreKeys": "← Aggiungi altre chiavi",
      "chooseProvider": "Scegli un provider",
      "chooseModel": "Scegli un modello",
      "modelsFor": "Modelli disponibili per {{provider}}",
      "activeKeys_one": "{{count}} chiave attiva",
      "activeKeys_other": "{{count}} chiavi attive",
      "startSession": "Avvia sessione"
    },
    "card": {
      "keySaved": "Chiave salvata",
      "referral": "Invito",
      "save": "Salva",
      "getKey": "Ottieni la tua chiave API",
      "copied": "Copiato",
      "copyReferral": "Copia link di invito",
      "share": "Condividi",
      "qrAlt": "Codice QR di invito {{name}}"
    },
    "share": {
      "title": "Condividi invito {{name}}",
      "description": "Condividi questo link di invito con gli amici e ottieni ricompense!",
      "hint": "Scansiona il codice QR o copia il link per condividere",
      "twitter": "Condividi su X/Twitter",
      "linkedin": "Condividi su LinkedIn",
      "telegram": "Condividi su Telegram",
      "whatsapp": "Condividi su WhatsApp",
      "reddit": "Condividi su Reddit",
      "facebook": "Condividi su Facebook",
      "email": "Condividi via email"
    },
    "custom": {
      "title": "Provider personalizzato / self-hosted",
      "description": "Aggiungi qualsiasi endpoint compatibile con OpenAI (Ollama, vLLM, Together, ecc.)",
      "localServers": "Server locali — clicca per precompilare",
      "providerId": "ID provider *",
      "family": "Famiglia",
      "familyOpenAiCompatible": "Compatibile con OpenAI",
      "baseUrl": "URL di base (facoltativo)",
      "apiKey": "Chiave API (facoltativa — alcuni provider locali non la richiedono)",
      "apiKeyPlaceholder": "Chiave API (se richiesta)",
      "add": "Aggiungi provider"
    },
    "time": {
      "justNow": "adesso",
      "secondsAgo": "{{count}} sec fa",
      "minutesAgo": "{{count}} min fa",
      "hoursAgo": "{{count}} h fa",
      "daysAgo": "{{count}} g fa"
    },
    "toasts": {
      "keySaved": "Chiave API {{name}} salvata",
      "keySaveFailed": "Salvataggio della chiave API {{name}} non riuscito",
      "referralCopied": "Link di invito copiato negli appunti",
      "referralCopyFailed": "Copia del link di invito non riuscita",
      "providerAdded": "Provider \"{{id}}\" aggiunto",
      "providerAddFailed": "Aggiunta del provider non riuscita",
      "providersLoadedNew": "{{count}} provider caricati ({{diff}} nuovo)",
      "providersLoadedRemoved": "{{count}} provider caricati ({{diff}} rimosso)",
      "providersLoadedNoChanges": "{{count}} provider caricati (nessuna modifica)",
      "providersRefreshFailed": "Aggiornamento dei provider non riuscito"
    }
  }
}
